<template>
    <div class="animated fadeIn container-fluid">
        <div>
            <b-row>
                <b-col md="4">
                    <h3>
                        {{ $t('menu.projects') }}
                    </h3>
                </b-col>
                <b-col md="8">
                    <router-link class="link-item" :to="{ name: 'New Project' }">新增專案 New Project</router-link>
                </b-col>

            </b-row>


            <div>

                <!-- Admin 專案搜尋 -->
                <b-button variant="warning" class="block-text" @click="collapse_search = !collapse_search">
                    <b-badge variant="danger" class="btn-red block-text">Admin</b-badge> Search
                    <i :class="$tools.style.classToggle(collapse_search)"></i>
                </b-button>

                <b-collapse id="collapse_search" v-model="collapse_search">
                    <b-card class="block-area">

                        <p class="instruction text-center">
                            <i class="fa fa-info-circle"></i> 進入此頁預設會搜尋最近修改的 10 個專案。
                        </p>

                        <b-row align-h="center">
                            <b-col sm=10 md=8>
                                <SearchProjects :search_on_show="true"></SearchProjects>
                            </b-col>
                        </b-row>

                    </b-card>
                </b-collapse>


                <!-- Admin 專案列表 -->
                <AdminProjects></AdminProjects>

            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SearchProjects from '@/views/admin/components/Search_Projects'
import AdminProjects from '@/views/home/components/Admin_Projects'

export default {

    components: {
        SearchProjects,
        AdminProjects,
    },
    data: function () {
        return {
            collapse_search: true,
        }
    },
    mounted ()
    {
    },
    computed:
    {
        ...mapState({
        'admin_Project_List': state => state.project.projects,
        }),

        projects ()
        {
            return (this.admin_Project_List ? this.admin_Project_List : [] )
        },
    },
    methods:
    {
        goToPage: function (type, params)
        {
            this.$router.push( this.$config.getPagesURL(type, params) );
        },

        style_Expiry (projInfo)
        {
            let _class = 'expiry-date'
            let _diff_days = this.$tools.date.countDays( projInfo.end_date, undefined, projInfo.timezone )
            if ( Math.abs( _diff_days ) <= 30 ) _class += '-due'
            return _class
        },


    },

}
</script>

<style lang="scss" scoped>

</style>
